import { ActivityList } from "./ActivityList";
import { glass, heading } from "../styles.js";

const ActivityView = ({ activity, clients, properties, onOpenClient, onOpenProperty }) => (
    <div className="space-y-4">
      <div>
        <h1 className="text-4xl text-slate-100 mb-1" style={heading}>
          Activity
        </h1>
        <p className="text-sm text-slate-400">Every change, in order.</p>
      </div>
      <div className={`${glass} rounded-2xl p-5`}>
        {activity.length === 0 ? (
          <div className="text-sm text-slate-500 py-8 text-center">
            Nothing yet — actions you take will show up here.
          </div>
        ) : (
          <ActivityList
            items={activity}
            clients={clients}
            properties={properties}
            onOpenClient={onOpenClient}
            onOpenProperty={onOpenProperty}
          />
        )}
      </div>
    </div>
  );

export { ActivityView };
